import { createStyles, TableFooter, WithStyles, withStyles } from '@material-ui/core';
import { TableFooterProps } from '@material-ui/core/TableFooter';
import * as React from 'react';

type CustomTableFooterProps =
    & WithStyles<typeof styles>
    & TableFooterProps;

const CustomTableFooter: React.FC<CustomTableFooterProps> = props => {
    const { classes, ...rest } = props;

    return <TableFooter className={classes.footer} {...rest} />;

}

const styles = () => createStyles({
    footer: {
        "& div": {
            backgroundColor: "unset"
        }
    }
});

export default withStyles(styles)(CustomTableFooter);
